var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.20653 0C11.1801 0 14.4127 3.2326 14.4127 7.20579C14.4127 8.94057 13.7997 10.576 12.6953 11.8751L13.8325 13.0127L14.2426 12.6022C14.4691 12.3761 14.8364 12.3761 15.0625 12.6022L19.6213 17.161C19.8474 17.3871 19.8478 17.7543 19.6213 17.9809L17.9812 19.6209C17.7547 19.847 17.3879 19.8474 17.1614 19.6209L12.603 15.0621C12.3764 14.836 12.3764 14.4688 12.603 14.2423L13.0127 13.8326L11.8755 12.695C10.5733 13.802 8.93666 14.4124 7.20653 14.4124C3.23295 14.4124 0.000350952 11.1798 0.000350952 7.20579C0.000350952 3.2326 3.23295 0 7.20653 0ZM7.20653 3.47882C9.26174 3.47882 10.9339 5.15097 10.9339 7.20618C10.9339 7.52623 11.1936 7.78598 11.5137 7.78598C11.8341 7.78598 12.0935 7.52623 12.0935 7.20618C12.0935 4.51164 9.90107 2.31921 7.20653 2.31921C6.88648 2.31921 6.62673 2.57896 6.62673 2.89902C6.62673 3.21907 6.88648 3.47882 7.20653 3.47882Z",
    fill: "#86FFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIco);
export default __webpack_public_path__ + "static/media/searchIco.8bcd8ab7de23f2e291427221ad96d889.svg";
export { ForwardRef as ReactComponent };